module.exports = Settings;